export default __webpack_public_path__ + "static/media/icon.571f5b58.svg";